var map = {
	"./favicon.png": "Yhqy",
	"./github.jpg": "7Qja",
	"./hooks.png": "w+JK",
	"./karma.png": "m2UG",
	"./meal-planner.jpg": "ijby",
	"./monorepo.png": "3YOm",
	"./translations.gif": "NYbF"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2qD";